import { Permission } from "@edgetier/watchtower-types";
import {
    faBellOn,
    faBinoculars,
    faBolt,
    faChartBar,
    faClipboard,
    faCog,
    faSpellCheck,
    faTag,
    faTags,
    faUser,
    faUserChart,
    faUserEdit,
    faUserTag,
    faUsers,
    faUsersCog,
} from "@fortawesome/pro-solid-svg-icons";
import { NavigationCategories, NavigationLabels, PageNames } from "types-for/routes";
import { getDefaultRouteUrls } from "utilities/get-default-route-urls";

import { AbsolutePaths } from "./index";

const { faCustomersNavIcon } = require("@awesome.me/kit-67bf90e9a4/icons/kit/custom");

const defaultRouteUrls = getDefaultRouteUrls();

export const NavigationHierarchy = {
    [NavigationCategories.AgentReview]: {
        icon: faUser,
        permission: [Permission.ViewAgent, Permission.ViewReceivedReviews],
        children: [
            {
                page: defaultRouteUrls[PageNames.Agent].url,
                pageName: PageNames.Agent,
                permission: [Permission.ViewAgent, Permission.ViewAgentDetails],
                icon: faUser,
                label: NavigationLabels.Agent,
            },
            {
                page: defaultRouteUrls[PageNames.Agents].url,
                pageName: PageNames.Agents,
                permission: [Permission.ViewAgent],
                icon: faUsers,
                label: NavigationLabels.Agents,
            },
            {
                page: defaultRouteUrls[PageNames.Reviews].url,
                pageName: PageNames.Reviews,
                permission: [Permission.ManageAllReviews, Permission.ViewReceivedReviews, Permission.ManageOwnReviews],
                icon: faUserChart,
                label: NavigationLabels.Reviews,
            },
            {
                page: AbsolutePaths[PageNames.Scorecards](),
                pageName: PageNames.Scorecards,
                permission: [Permission.ManageScorecards],
                icon: faClipboard,
                label: NavigationLabels.Scorecards,
            },
        ],
    },
    [NavigationCategories.Anomalies]: {
        page: AbsolutePaths[PageNames.Anomalies](),
        pageName: PageNames.Anomalies,
        permission: [Permission.ViewAnomalies],
        icon: faBellOn,
        label: NavigationLabels.Anomalies,
    },
    [NavigationCategories.Explore]: {
        icon: faBinoculars,
        permission: [Permission.ViewExplore, Permission.ViewLive, Permission.ViewCustomReports],
        children: [
            {
                page: defaultRouteUrls[PageNames.Explore].url,
                pageName: PageNames.Explore,
                permission: [Permission.ViewExplore],
                icon: faBinoculars,
                label: NavigationLabels.Explore,
            },
            {
                page: defaultRouteUrls[PageNames.ExploreTags].url,
                pageName: PageNames.ExploreTags,
                permission: [Permission.ViewExplore],
                icon: faTag,
                label: NavigationLabels.ExploreTags,
            },
            {
                page: defaultRouteUrls[PageNames.Live].url,
                pageName: PageNames.Live,
                permission: [Permission.ViewLive],
                icon: faBolt,
                label: NavigationLabels.Live,
            },
            {
                page: AbsolutePaths[PageNames.CustomReports](),
                pageName: PageNames.CustomReports,
                permission: [Permission.ViewCustomReports],
                icon: faChartBar,
                label: NavigationLabels.CustomReports,
            },
        ],
    },
    [NavigationCategories.CustomerOverview]: {
        icon: faCustomersNavIcon,
        permission: [Permission.ViewExplore],
        page: defaultRouteUrls[PageNames.CustomerOverview].url,
        label: NavigationLabels.CustomerOverview,
        pageName: PageNames.CustomerOverview,
    },
    [NavigationCategories.Configuration]: {
        icon: faCog,
        permission: [
            Permission.ManagePhraseTriggers,
            Permission.ManageInteractionTags,
            Permission.ManageWritingIssues,
            Permission.ManageAgentTags,
        ],
        children: [
            {
                page: AbsolutePaths[PageNames.ManageTags](),
                pageName: PageNames.ManageTags,
                permission: [Permission.ManagePhraseTriggers, Permission.ManageInteractionTags],
                icon: faTags,
                label: NavigationLabels.TagsAndTriggers,
            },
            {
                // The empty string is neccessary. It replaces :tagId with an empty string for the initial page load.
                page: AbsolutePaths[PageNames.AgentGroup](""),
                pageName: PageNames.AgentGroup,
                permission: [Permission.ManageAgentTags],
                icon: faUsersCog,
                label: NavigationLabels.AgentGroups,
            },
            {
                page: AbsolutePaths[PageNames.SpellingConfiguration](),
                pageName: PageNames.SpellingConfiguration,
                permission: [Permission.ManageWritingIssues],
                icon: faSpellCheck,
                label: NavigationLabels.SpellingExemptions,
            },
        ],
    },
    [NavigationCategories.UserManagement]: {
        icon: faUsers,
        permission: [Permission.ManageUsers, Permission.ManageTeams, Permission.ManageRoles],
        children: [
            {
                page: AbsolutePaths[PageNames.Users](),
                pageName: PageNames.Users,
                permission: [Permission.ManageUsers],
                icon: faUserEdit,
                label: NavigationLabels.Users,
            },
            {
                page: AbsolutePaths[PageNames.Permission](),
                pageName: PageNames.Permission,
                permission: [Permission.ManageRoles],
                icon: faUserTag,
                label: NavigationLabels.Permissions,
            },
            {
                page: AbsolutePaths[PageNames.TeamsConfiguration](),
                pageName: PageNames.TeamsConfiguration,
                permission: [Permission.ManageTeams],
                icon: faUsersCog,
                label: NavigationLabels.TeamsConfiguration,
            },
        ],
    },
};
